import { useEffect, useState } from "react";
import {
  Users,
  ArrowUpRight,
  TrendingUp,
  ArrowDownRight,
  UserCheck,
  UserMinus,
  Gift,
  Calendar,
  FileText,
  IdCard,
  CheckCircle,
  Clock,
  BarChart3,
  AlertTriangle,
  RefreshCcw,
  Paperclip,
  MapPin,
} from "lucide-react";
import Skeleton from "@mui/material/Skeleton";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useNavigate } from "react-router";
import Style from "./style.module.css";
import WorkForceQuickView from "./popup";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { TableCard } from "../../../component/table/table-layout";
import { CustomDropdown } from "../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../component/ui/dropdown/CustomDropdownMenuList";
// import InnerLoader from "../../../component/ui/loader/inner-loader";
import HC_map from "highcharts/modules/map";
import worldMapData from "@highcharts/map-collection/custom/world.geo.json";
import isoCountries from "i18n-iso-countries";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DealList from "../task/Deals";
import DotsVerticalIcon from "../../../component/icons/dots-vertical";
import { KPI } from "../../../component/ui/layout";

const USE_DUMMY_DATA = true;


const Card = ({ className = "", children }) => (
  <div
    className={`w-full border border-[#E1E4EA] shadow rounded-[14px] flex flex-col border-slate-200/60 1darkborder-slate-800 bg-white 1darkbg-slate-900 ${className}`}
  >
    {children}
  </div>
);
const CardHeader = ({ className = "", children }) => (
  <div
    className={`p-4 md:p-5 border-b border-slate-100 1darkborder-slate-800 ${className}`}
  >
    {children}
  </div>
);
const CardTitle = ({ className = "", children }) => (
  <h3
    className={`text-lg md:text-xl font-semibold tracking-tight ${className}`}
  >
    {children}
  </h3>
);
const CardContent = ({ className = "", children }) => (
  <div className={`p-4 md:p-5 w-full h-full ${className}`}>{children}</div>
);

// --- Main Component ---
export default function TasksOverview() {
  // let data = "";
  const apiCall = useApiCall();
  const router = useNavigate();
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(false);
  const [activeChart, setActiveChart] = useState("New Leads vs Converted");
  const [selectedMonths, setSelectedMonths] = useState(6);

  const getKPIData = async () => {
    setKPILoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/lead-overview-kpi?view=myleads`,
      });
      setKPIData(resp?.data);
      setKPILoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getKPIData();
  }, []);

  // PIE CHART - Leads by Brand
  // const [brandData, setBrandData] = useState([]);
  // const [brandLoading, setBrandLoading] = useState(false);

  // const getLeadsByBrandData = async () => {
  //   setBrandLoading(false);
  //   const apiUrl = `leads/lead-overview-by-brand?view=myleads`;
  //   try {
  //     const res = await apiCall({ method: "get", url: apiUrl });
  //     setBrandData(res?.data);
  //   } catch (error) {
  //     console.warn("Error fetching brand data:", error);
  //   } finally {
  //     setBrandLoading(true);
  //   }
  // };

  // const brandOptions = {
  //   chart: {
  //     type: "pie",
  //   },
  //   title: "none",
  //   credits: { enabled: false },
  //   tooltip: {
  //     pointFormat:
  //       "{series.name}: <b>{point.count}</b><br/>Percentage: <b>{point.percentage:.1f}%</b>",
  //   },
  //   accessibility: {
  //     point: {
  //       valueSuffix: "%",
  //     },
  //   },
  //   plotOptions: {
  //     pie: {
  //       allowPointSelect: true,
  //       cursor: "pointer",
  //       dataLabels: {
  //         enabled: true,
  //         format:
  //           "<b>{point.name}</b>: {point.percentage:.1f}% ({point.count})",
  //       },
  //     },
  //   },
  //   series: [
  //     {
  //       name: "Leads",
  //       colorByPoint: true,
  //       data: brandData?.map((brand) => ({
  //         count: brand?.count,
  //         name: brand?.brand,
  //         y: parseFloat(brand.percent),
  //       })),
  //     },
  //   ],
  //   legend: { enabled: false }, // single series, legend not needed
  // };

  // brands with filters

  // PIE CHART - Leads by Brand
  const [brandData, setBrandData] = useState([]);
  const [brandLoading, setBrandLoading] = useState(false);
  const [brandFilter, setBrandFilter] = useState("all_time");

  const getLeadsByBrandData = async () => {
    setBrandLoading(false);

    const apiUrl = `leads/lead-overview-by-brand?view=myleads&filter=${brandFilter}`;

    try {
      const res = await apiCall({ method: "get", url: apiUrl });
      setBrandData(res?.data);
    } catch (error) {
      console.warn("Error fetching brand data:", error);
    } finally {
      setBrandLoading(true);
    }
  };

  useEffect(() => {
    getLeadsByBrandData();
  }, [brandFilter]);

  const [showWorkForce, setShowWorkForce] = useState(false);
  const [popupData, setPopupData] = useState({});

  // Heat Chart

  // Project Progress Chart
  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 350,

      // 🔥 For center title
      events: {
        render: function () {
          const chart = this;

          // Remove previous custom labels
          if (chart.customCenterTitle) chart.customCenterTitle.destroy();
          if (chart.customCenterSubtitle) chart.customCenterSubtitle.destroy();

          const total = chart.series[0].data.reduce((a, b) => a + b.y, 0);

          // Center coordinates
          const centerX = chart.plotWidth / 2 + chart.plotLeft;
          const centerY = chart.plotHeight / 2 + chart.plotTop;

          // 🔵 Main total number
          chart.customCenterTitle = chart.renderer
            .text(total, centerX, centerY - 5)
            .css({
              fontSize: "22px",
              fontWeight: "600",
              color: "#000",
              textAlign: "center",
            })
            .attr({ align: "center" })
            .add();

          // 🔵 Subtitle
          chart.customCenterSubtitle = chart.renderer
            .text("Total Projects", centerX, centerY + 18)
            .css({
              fontSize: "13px",
              fontWeight: "400",
              color: "gray",
              textAlign: "center",
            })
            .attr({ align: "center" })
            .add();
        },
      },
    },

    title: null,
    credits: { enabled: false },

    tooltip: {
      pointFormat: "<b>{point.y}</b> ({point.percentage:.1f}%)",
    },

    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginTop: 8,
      itemStyle: {
        fontSize: "13px",
        color: "#374151",
      },
    },

    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        dataLabels: { enabled: false },
        innerSize: "60%", // donut ring
      },
    },

    // ✅ Updated project status data
    series: [
      {
        name: "Projects",
        colorByPoint: true,
        data: [
          { name: "Draft", y: 30, color: "#E1E4EA" },
          { name: "In Process", y: 60, color: "#0057FB" },
          { name: "Completed", y: 120, color: "#84CC16" },
          { name: "Rejected", y: 30, color: "#FF4040" },
        ],
      },
    ],
  };

  //
  const taskStats = [
    {
      month: "Resume",
      todo: 120,
      inprocess: 80,
      completed: 150,
      feedback: 40,
      rejected: 15,
    },
    {
      month: "Software",
      todo: 100,
      inprocess: 90,
      completed: 130,
      feedback: 30,
      rejected: 22,
    },
    {
      month: "Rank By Monday",
      todo: 140,
      inprocess: 110,
      completed: 170,
      feedback: 50,
      rejected: 18,
    },
    {
      month: "Wix Profs",
      todo: 140,
      inprocess: 110,
      completed: 170,
      feedback: 50,
      rejected: 18,
    },
    {
      month: "Shopify",
      todo: 140,
      inprocess: 110,
      completed: 170,
      feedback: 50,
      rejected: 18,
    },
    {
      month: "SEO",
      todo: 140,
      inprocess: 110,
      completed: 170,
      feedback: 50,
      rejected: 18,
    },
    {
      month: "Shopify PRf",
      todo: 140,
      inprocess: 110,
      completed: 170,
      feedback: 50,
      rejected: 18,
    },
  ];

  const totalOrdersOptions = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 400,
    },

    title: { text: "" },

    xAxis: {
      categories: taskStats.map((d) => d.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },

    yAxis: {
      min: 0,
      title: { text: "" },
      gridLineColor: "#DCDCDC",
      gridLineDashStyle: "LongDash",
      labels: { style: { color: "#6B7280" } },
      tickInterval: 50,
    },

    legend: {
      enabled: true,
      itemStyle: { color: "#374151", fontSize: "12px" },
    },

    plotOptions: {
      column: {
        borderRadius: 8,
        pointWidth: 10, // smaller width because we have 5 bars now
        groupPadding: 0.15,
        pointPadding: 0.05,
        states: {
          hover: { enabled: true, brightness: 0 },
          inactive: { opacity: 0.9 },
        },
      },
    },

    tooltip: {
      shared: true,
      useHTML: true,
    },

    series: [
      {
        name: "To-Do",
        color: "#FF7F50",
        data: taskStats.map((d) => d.todo),
      },
      {
        name: "In-Process",
        color: "#0057FB",
        data: taskStats.map((d) => d.inprocess),
      },
      {
        name: "Completed",
        color: "#84CC16",
        data: taskStats.map((d) => d.completed),
      },
      {
        name: "Pending Feedback",
        color: "#BF83FF",
        data: taskStats.map((d) => d.feedback),
      },
      {
        name: "Rejected",
        color: "#FF4040",
        data: taskStats.map((d) => d.rejected),
      },
    ],

    credits: { enabled: false },
  };

  return (
    <>
      <div className="pt-[20px] overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div>
            <h1 className="text-xl font-bold pl-3">Tasks Metrics</h1>
          </div>

          {/* KPI Row */}
          <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {!KPILoading ? (
                <>
                  <KPI icon={Users} label="In Process" value={8} />
                  <KPI icon={Users} label="Todo" value={4} />
                  <KPI icon={Users} label="Completed" value={12} />
                  <KPI icon={Users} label="Pending Feedback" value={16} />
                  <KPI icon={Users} label="Rejected" value={2} />
                  <KPI icon={Users} label="New Tasks" value={9} />
                </>
              ) : (
                Array.from({ length: 6 }).map((_, index) => (
                  <div
                    key={index}
                    className="bg-white shadow rounded-xl p-4 animate-pulse"
                  >
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                    </div>
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={20} height={40} />
                      <Skeleton variant="circular" width={30} height={30} />
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mt-6">
              {/* Bar Chart */}
              <Card className="col-span-3 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" /> Team Tasks Reports
                  </CardTitle>
                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown !w-[200px]"
                  >
                    <CustomDropdownButton
                      arrow={true}
                      className="btnClass !w-[200px] !justify-between"
                    >
                      <h3 className="!text-[16px] capitalize">
                        {brandFilter.replace("_", " ")}
                      </h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      {brandFilter !== "all_time" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("all_time")}
                        >
                          All Time
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_year" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_year")}
                        >
                          This Year
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_quarter" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_quarter")}
                        >
                          This Quarter
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "last_month" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("last_month")}
                        >
                          Last Month
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_month" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_month")}
                        >
                          This Month
                        </CustomDropdownMenuList>
                      )}
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </CardHeader>
                <CardContent>
                  {brandLoading ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={totalOrdersOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* Donut Chart */}
              <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" /> Project Reports
                  </CardTitle>
                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown !w-[200px]"
                  >
                    <CustomDropdownButton
                      arrow={true}
                      className="btnClass !w-[200px] !justify-between"
                    >
                      <h3 className="!text-[16px] capitalize">
                        {brandFilter.replace("_", " ")}
                      </h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      {brandFilter !== "all_time" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("all_time")}
                        >
                          All Time
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_year" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_year")}
                        >
                          This Year
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_quarter" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_quarter")}
                        >
                          This Quarter
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "last_month" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("last_month")}
                        >
                          Last Month
                        </CustomDropdownMenuList>
                      )}

                      {brandFilter !== "this_month" && (
                        <CustomDropdownMenuList
                          onClick={() => setBrandFilter("this_month")}
                        >
                          This Month
                        </CustomDropdownMenuList>
                      )}
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </CardHeader>
                <CardContent>
                  {brandLoading ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              <div className="col-span-1 md:col-span-5  p-5 min-h-[400px] max-h-[450px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <div className="flex items-center justify-between  overflow-hidden">
                  Tasks
                  <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                    <DotsVerticalIcon />
                  </div>
                </div>

                <DealList />
              </div>
            </div>
          </TableCard>
        </div>
      </div>

      {showWorkForce && (
        <WorkForceQuickView
          onClose={() => setShowWorkForce(false)}
          apiKey={popupData.apiKey}
          apiUrl={popupData.apiUrl}
          pagUrl={popupData.pagUrl}
          title={popupData.title}
          subTitle={popupData.subTitle}
          icon={popupData.icon}
          positive={popupData?.positive}
          stateLable={popupData?.stateLable}
          positiveIcon={popupData?.positiveIcon}
        />
      )}
    </>
  );
}
